import { LotteryEntries } from 'features/LotteryEntries';
import { PunchupLotteryEntries } from 'features/PunchupPages/LotteryEntries';
import { useAppSelector } from 'store/hooks';

const LotteryPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);
	if (isPunchup && greenZoneEnabled) return <PunchupLotteryEntries />;
	return <LotteryEntries />;
};
export default LotteryPage;
